import React, { useState, useRef, useEffect } from "react";
import { Image, Row } from "react-bootstrap";
import "./Stock.scss";
import i18n from "utils/I18n";
import CouponIcon from "../../assets/images/coupon_icon.svg";
import { enLocaleNumberFormatter } from "../../utils";
import { detectIsPadOrMobileByScreenWidth } from "utils/ScreenUtils";

function Stock({ coupon }) {
  const stockNumberRef = useRef(null);
  const [lastUpdateSectionMaxWidth, setLastUpdateSectionMaxWidth] = useState(window.innerWidth);
  const isPadOrMobileView = detectIsPadOrMobileByScreenWidth();
  useEffect(() => {
    if (stockNumberRef.current) {
      const stockSectionWidth = stockNumberRef.current.offsetWidth;
      const screenWidth = window.innerWidth;
      setLastUpdateSectionMaxWidth(screenWidth - stockSectionWidth - 30 - 20); // 30 is stock_container horizontal margin, 20 is coupon icon width
    }
  }, []);

  return (
    <div className="stock_container">
      <Row>
        <div>
          <Image className="coupon-icon" src={CouponIcon} />
        </div>
        <div className="left_stock ">
          <div className={`stock_title ${isPadOrMobileView ? "body-2" : "headline"}`}>
            {coupon.isTicket ? i18n.t("ticketLeft") : i18n.t("campaignDetail:couponLeft")}
          </div>
          <div className={`stock-update-time-container ${isPadOrMobileView ? "tag-menu-1" : "body-1"}`} style={{ maxWidth: lastUpdateSectionMaxWidth }}>
            <div className="stock-update-time-item">
              {`${i18n.t("campaignDetail:lastUpdated")} `}
            </div>
            <div className="stock-update-time-item">
              {coupon.lastUpdateTime}
            </div>
          </div>

        </div>
        <div className="right_stock" ref={stockNumberRef}>
          <div className={`left_num ${isPadOrMobileView ? "title-small" : "title-medium-2"}`}>{enLocaleNumberFormatter(coupon.leftStock)}</div>
        </div>
      </Row>
    </div>
  );
}

export default Stock;